<template>
  <component
    :is="to ? 'router-link' : 'button'"
    :to="to"
    class="icon-button"
    :class="{ transparent, small }"
    @click="$emit('click')">
    <Icon class="icon-button-icon" :name="iconName" />
    <span class="paragraph">
      <slot />
    </span>
    <Icon class="icon-button-arrow" v-if="arrow" name="arrow" />
  </component>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { RouteRecordRaw } from 'vue-router';

export default defineComponent({
  emits: ['click'],
  props: {
    iconName: {
      type: String,
      required: true,
    },
    to: {
      type: Object as PropType<RouteRecordRaw>,
    },
    arrow: {
      type: Boolean,
    },
    transparent: {
      type: Boolean,
    },
    small: {
      type: Boolean,
    },
  },
});
</script>

<style lang="scss" scoped>
.icon-button {
  display: flex;
  color: $white;
  align-items: center;
  width: fit-content;
  text-decoration: none;
  padding: 0;

  &:not(.transparent) {
    border: 1px solid white;
    padding: rem(8) rem(16);
    border-radius: rem(12);
    background-color: rgba(0, 0, 0, 0.3);
  }

  &.small {
    padding: rem(8);
    margin: rem(-8);

    .icon-button-icon {
      width: rem(28);
      height: rem(28);
      margin-right: rem(12);
    }
  }

  &-icon {
    width: rem(42);
    height: rem(42);
    margin-right: rem(16);
  }

  &-arrow {
    width: rem(12);
    height: rem(12);
    margin-left: rem(10);
  }
}
</style>
